<div class="row">
  <div class="col-sm-10">
    <div class="row no-gutters">
      <mat-form-field class="full-width">
        <mat-label>Common textarea</mat-label>
        <textarea matInput
                  rows="8"
                  [(ngModel)]="comment"
        ></textarea>
      </mat-form-field>
    </div>
  </div>
  <div class="col-sm-2">
    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
  </div>
</div>
